import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import { IRootReducer } from "../../redux/reducers";
import { getHasAccess } from "../../redux/selectors/auth.selectors";
import { IRoute } from "../interfaces/route.interface";

const PrivateRoute : React.FC<IRoute> = ({ component, exact, path }) => {
    const state = useSelector((state:IRootReducer) => state);
    const isUserLoggedIn = getHasAccess(state);

    return (
        isUserLoggedIn ? (
            <Route exact={exact} path={path} component={component} />
        ) : <Redirect to="/login" />
    )
}

export default PrivateRoute;